import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import { FilePreview } from "./FilePreview/FilePreview";
import { styled } from "styled-components";

type Props = {
  attachmentKeys: string[];
};

export const AttachmentViewer = ({ attachmentKeys }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography
        sx={{ marginBottom: "6px" }}
        variant="body-x-small"
        color={"GRAY_BLACK"}
      >
        {t("MESSAGE_ATTACHMENT_TITLE")}
      </Typography>
      <ViewerContainer>
        {attachmentKeys.map((key) => (
          <FilePreview type="view" key={key} attachmentKey={key} />
        ))}
      </ViewerContainer>
    </div>
  );
};

const ViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.PADDING.MD};
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLORS.LIGHT_ACTION_BLUE};
  gap: ${({ theme }) => theme.SPACING.SM};
`;
